import { useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { SalesRepositoryToken } from '../../di/tokens';

/**
 * Hooks por aba do detalhe da transação. Cada um só dispara quando `enabled`
 * (aba aberta), implementando o carregamento sob demanda. `retry: false` porque
 * um elo da cadeia pode legitimamente não existir (404).
 */

export function useTransactionInvoices(transactionId: string, enabled = true) {
  const repository = container.resolve(SalesRepositoryToken);
  return useQuery({
    queryKey: ['sales', 'transaction', transactionId, 'invoices'],
    queryFn: () => repository.getTransactionInvoices(transactionId),
    staleTime: 1000 * 60 * 5,
    enabled: !!transactionId && enabled,
    retry: false,
  });
}

export function useTransactionContract(transactionId: string, enabled = true) {
  const repository = container.resolve(SalesRepositoryToken);
  return useQuery({
    queryKey: ['sales', 'transaction', transactionId, 'contract'],
    queryFn: () => repository.getTransactionContract(transactionId),
    staleTime: 1000 * 60 * 5,
    enabled: !!transactionId && enabled,
    retry: false,
  });
}

export function useTransactionBillingAgreement(
  transactionId: string,
  enabled = true,
) {
  const repository = container.resolve(SalesRepositoryToken);
  return useQuery({
    queryKey: ['sales', 'transaction', transactionId, 'billing-agreement'],
    queryFn: () => repository.getTransactionBillingAgreement(transactionId),
    staleTime: 1000 * 60 * 5,
    enabled: !!transactionId && enabled,
    retry: false,
  });
}

export function useTransactionOfferAndArrangements(
  transactionId: string,
  enabled = true,
) {
  const repository = container.resolve(SalesRepositoryToken);
  return useQuery({
    queryKey: ['sales', 'transaction', transactionId, 'offer-arrangements'],
    queryFn: () => repository.getTransactionOfferAndArrangements(transactionId),
    staleTime: 1000 * 60 * 5,
    enabled: !!transactionId && enabled,
    retry: false,
  });
}
